// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { executeAwaitableHandlerChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadProducts from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import {
    chain,
    GetUnfilteredProducts,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { getProductListDataViewProperty } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
export const XngPopulateApiParameter: any = (props: any) => {
    const brandId = props?.parameter?.brandId;
    const filters = props.result.productFilters;
    const {
        query,
        brandIds,
        productLineIds,
        priceFilters,
        attributeValueIds,
        searchWithinQueries,
        pageCategoryId,
        pageBrandId,
        pageProductLineId,
        ...apiParameter
    } = filters;

    const expand = ["attributes", "facets", "getbadges", "getstyledchildrencount", "properties"];
    if (brandId) expand.push("branddata");

    props.apiParameter = {
        ...apiParameter,
        search: query,
        categoryId: filters.categoryId || filters.pageCategoryId,
        searchWithin: searchWithinQueries?.join(" "),
        includeSuggestions: filters.includeSuggestions !== false,
        brandIds: filters.pageBrandId && !brandIds ? [filters.pageBrandId] : brandIds,
        productLineIds: filters.pageProductLineId ? [filters.pageProductLineId] : productLineIds,
        priceFilters,
        attributeValueIds,
        expand,
        applyPersonalization: true,
        includeAttributes: ["includeOnProduct"],
        relevancy: props.parameter.relevancy,
        includeProductsInSubCategories: !!(
            filters.categoryId?.length ||
            filters.pageCategoryId?.length ||
            props.result.catelogPage?.categoryId.length
        ),
        searchHub: props.parameter.isSearch ? "search" : "listing",
    };

    const currentPage = props.getState().pages.productList.parameter?.page || 1;
    if (props.apiParameter.page === currentPage + 1) {
        props.apiParameter.pageToken = getProductListDataViewProperty(props.getState(), "pagination")?.nextPageToken;
    }
};

// Dont delete the categoryId in case we have include products for subCategories to fetch all the categoryFacets with the call
export const XngGetUnfilteredProducts: any = async (props: any) => {
    const unfilteredApiParameter = { ...props.apiParameter };

    delete unfilteredApiParameter.searchWithin;
    delete unfilteredApiParameter.priceFilters;
    delete unfilteredApiParameter.attributeValueIds;

    if (!props.result.productFilters.pageProductLineId) {
        delete unfilteredApiParameter.productLineIds;
    }
    if (!unfilteredApiParameter.includeProductsInSubCategories && !props.result.productFilters.pageCategoryId) {
        delete unfilteredApiParameter.categoryId;
    }
    if (!props.result.productFilters.pageBrandId) {
        delete unfilteredApiParameter.brandIds;
    }

    unfilteredApiParameter.stockedItemsOnly = undefined;

    props.result.unfilteredApiParameter = unfilteredApiParameter;
    props.result.filteredApiParameter = { ...props.apiParameter };

    const unfilteredProducts = getProductsDataView(props.getState(), unfilteredApiParameter).value;

    if (unfilteredProducts) {
        return;
    }

    await executeAwaitableHandlerChain(loadProducts, unfilteredApiParameter, props);
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
replaceInChain(chain, GetUnfilteredProducts, XngGetUnfilteredProducts);
